import { useContext } from 'react';
import { ThemeSettingsContext } from '../context/themeSettingsContext';

const useThemeMode = () => useContext(ThemeSettingsContext);

export default useThemeMode;
